(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-stacked-testimonials-carousel]').forEach(function (wrapper) {
    var items = wrapper.querySelectorAll('.testimonial__slider-item');
    if (!items.length) return;

    var current = 0;

    function showSlide(index) {
      // Wrap around infinite loop
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;

      items.forEach(function (item, i) {
        item.style.display = i === index ? '' : 'none';
      });

      current = index;
    }

    // Init: show first slide only
    showSlide(0);

    wrapper.querySelectorAll('.slide_arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function (e) {
        e.preventDefault();
        var direction = this.getAttribute('data-direction');
        showSlide(direction === 'next' ? current + 1 : current - 1);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
